<template>
  <div class="partners" :class="{'partners_full-width': fullWidth}">
    <div class="partners__container">
      <div v-if="title" class="partners__title" v-html="title"></div>
      <div class="partners__items">
        <div class="items__slider">
          <Slider 
            :cols="cols"
            :rows="rows"
            :navigationOffset="navigationOffset"
            :paginationOffset="paginationOffset"
            :loop="loop"
          >
            <PartnerCard 
              v-for="(item, i) in items" 
              :key="i"
              :link="item.link"
              :image="item.image"
            ></PartnerCard>
          </Slider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from '@sc-component-library/slider/src/main';
import PartnerCard from './PartnerCard.vue';

export default {
  name: 'Partners',
  designVersion: '1.0.0',
  components: {
    Slider,
    PartnerCard,
  },
  props: {
    /**
     * Текст заголовка
     */
    title: {
      type: String,
    },
    /**
     * Массив со свойствами карточек для слайдера<br>
     * `[ { image: Picture1, link: '/1' }, ... ]`<br>
     * поле `image` - изображение карточки<br>
     * поле `link` - ссылка для перехода при нажатии на карточку
     */
    items: {
      type: Array,
    },
    /**
     * Область контента на всю ширину или 1024px
     */
    fullWidth: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    cols() {
      return { default: '2', md: '3', lg: '3', xl: '3' };
    },
    rows() {
      return { default: '3', md: '2', lg: '2', xl: '2' };
    },
    navigationOffset() {
      return { default: '0', md: '72', lg: '72', xl: '84' };
    },
    paginationOffset() {
      return { default: '28', md: '44', lg: '44', xl: '60' };
    },
    loop() {
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./Partners";
</style>
